import CryptoJS from 'crypto-js';

/**
 * 计算请求签名
 * @param serverSeed - 服务端返回的签名种子
 * @param timestamp - 时间戳（毫秒级）
 * @param method - HTTP 请求方法（GET/POST）
 * @param path - 请求路径（不带域名）
 * @param deviceId - 设备ID
 * @returns 计算得到的签名字符串
 */
export function calculateSignature(
  serverSeed: string,
  timestamp: number,
  method: string,
  path: string,
  deviceId: string
): string {
  console.log('Calculating signature with timestamp:', timestamp);
  // 1. 计算时间窗口 (TimeSlot)
  // 务必使用请求头 X-Timestamp 的值进行计算
  const timeSlot = Math.floor(timestamp / 60000);

  // 2. 计算动态盐 (FinalSalt)
  // 算法: SHA256(serverSeed + timeSlot)
  const finalSalt = CryptoJS.SHA256(serverSeed + timeSlot).toString(CryptoJS.enc.Hex);

  // 3. 计算签名 (Signature)
  // 拼接顺序固定: method + path + deviceId + timestamp + finalSalt
  // 注意: method全大写, path不带域名
  // IP因子已被网关剔除（前端难以准确获取公网出口IP）
  const rawString = method.toUpperCase() + path + deviceId + timestamp + finalSalt;
  const signature = CryptoJS.SHA256(rawString).toString(CryptoJS.enc.Hex);

  return signature;
}
